module.exports = __webpack_public_path__ + "static/ru-3-485570fe701a67f7a2b8e4ad980fd2d9.png";